import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';
import { AgencyAvailability } from '../types/AgencyAvailability';

const AGENCY_AVAILABILITY_URL = '/v2/admin/agency-availability';
const UPLOAD_URL = '/upload';

class AgencyAvailabilityAdminService {

  static findByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<AgencyAvailability>> {
    return axios.get(AGENCY_AVAILABILITY_URL, config);
  }

  static upload(file: FormData, config?: AxiosRequestConfig): Promise<DataResponse<AgencyAvailability>> {
    return axios.post(AGENCY_AVAILABILITY_URL + UPLOAD_URL, file, config);
  }

  static create(data: AgencyAvailability, config?: AxiosRequestConfig): Promise<DataResponse<AgencyAvailability>> {
    return axios.post(AGENCY_AVAILABILITY_URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${AGENCY_AVAILABILITY_URL}/${id}`, config);
  }
}

export { AgencyAvailabilityAdminService };
